var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7,157.4l1,1.63c8.35,13.76,23.45,22.05,39.36,21.05a41.68,41.68,0,0,0,6.09-.84,45.29,45.29,0,0,0,32.29-28.06c3.07-8.24,3.92-17.73,9.75-24.27,7.58-8.52,20.45-8.78,31.76-8.43s24.2,0,31.74-8.5c4.73-5.35,6.23-13,5.85-20.13-1-19-14.24-36-31.06-44.39s-36.62-9.2-55-5.48C73.65,45.17,49.12,59.45,34.38,81.5S15.91,133.6,27.7,157.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.34,
    cy: 421.61,
    r: 20.14,
    transform: "translate(-217.04 568.4) rotate(-76.6)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.89,101.8c-2.45-23-16.85-39.1-34.54-54C421.42,27.58,390.65,27,375.14,27.9c-19.09,0-32.4,14.69-36.17,29s3.67,30.7,16.9,37.27c9.57,4.74,21.89,5.07,28.71,13.29,5.92,7.13,5.33,17.44,7.87,26.35,6.37,22.26,34.9,33.65,56.29,24.8S482.35,124.81,479.89,101.8Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.32,404.65h0s-.63,34.83-.63,47.75H408.57V415.66L405.09,406l-1.25-7.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.29,451a82.49,82.49,0,0,1-.61-9.24,84.8,84.8,0,0,1-.09-9.27,83.06,83.06,0,0,1,.61,9.25A84.6,84.6,0,0,1,328.29,451Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,416.84s.2-.15.64-.21a3.24,3.24,0,0,1,1.83.31,2.91,2.91,0,0,1,1.67,2.21,3,3,0,0,1-1.44,3,2.79,2.79,0,0,1-3.3-.65,2.15,2.15,0,0,1-.56-1.45,2.28,2.28,0,0,1,.39-1.28,2.33,2.33,0,0,1,1.53-1.07c.45-.06.69.05.68.07s-.25,0-.63.13a2.29,2.29,0,0,0-1.27,1.06,1.84,1.84,0,0,0,.22,2.22,2.33,2.33,0,0,0,2.69.51,2.57,2.57,0,0,0-.15-4.47A4.32,4.32,0,0,0,332.05,416.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.55,419.2a10.07,10.07,0,0,1-2.12-1.23c-1.26-.83-3-2.05-4.76-3.49s-3.35-2.85-4.43-3.9a9.87,9.87,0,0,1-1.66-1.8,12.7,12.7,0,0,1,1.91,1.53c1.14,1,2.72,2.33,4.5,3.76s3.45,2.69,4.65,3.6A13.23,13.23,0,0,1,392.55,419.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.82,430.64a2,2,0,0,1-.48.27l-1.44.69-1,.49c-.38.17-.82.32-1.28.49-.92.33-2,.77-3.16,1.08l-1.88.53c-.65.18-1.35.29-2.06.45-1.42.34-3,.51-4.6.73A49.76,49.76,0,0,1,366.8,433a45.42,45.42,0,0,1-4.33-1.72c-.66-.3-1.32-.57-1.92-.88l-1.71-.93a30.75,30.75,0,0,1-2.85-1.75c-.41-.27-.8-.51-1.15-.75s-.63-.49-.91-.71l-1.25-1c-.28-.23-.42-.35-.41-.37a3,3,0,0,1,.47.29l1.31.91.93.66c.35.23.75.46,1.17.72.84.5,1.76,1.13,2.87,1.66l1.71.9c.6.3,1.25.55,1.91.85,1.31.62,2.78,1.1,4.31,1.65a50.61,50.61,0,0,0,20.87,2.31c1.62-.2,3.16-.35,4.57-.67.71-.15,1.4-.25,2.05-.42l1.87-.5c1.2-.28,2.23-.69,3.16-1,.46-.16.9-.3,1.29-.45l1.06-.44,1.47-.6A2.24,2.24,0,0,1,403.82,430.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.13,170.44a7,7,0,0,1-2.26-13.73,7.27,7.27,0,0,1,6.95-11.93,8.71,8.71,0,0,1,13.48-6.46,9.78,9.78,0,0,1,12.05.37,7,7,0,0,1,5.54,12.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.07,171.36A29.67,29.67,0,0,1,349,145.58l1.54.08c16.5,1.78,24.2,16.8,21.95,33.24l-5.13,55-.28,2.67-38.56,5.76.75-14S313.44,225,314,209.09C314.32,201.4,316.2,185.62,318.07,171.36Z",
    style: {
      fill: "#937263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.1,228.24a38.59,38.59,0,0,0,21.14-5.06s-5.47,11.2-21.27,9Z",
    style: {
      fill: "#5e483f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.71,183.86a2.28,2.28,0,0,0,2.07,2.4,2.18,2.18,0,0,0,2.45-1.93,2.29,2.29,0,0,0-2.08-2.41A2.19,2.19,0,0,0,320.71,183.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,179.32c.27.31,2-.88,4.5-.75s4.17,1.43,4.45,1.15c.14-.13-.12-.68-.88-1.28a6.19,6.19,0,0,0-3.54-1.29,6,6,0,0,0-3.6,1C321.25,178.65,321,179.18,321.1,179.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.79,186.06a2.26,2.26,0,0,0,2.07,2.4,2.19,2.19,0,0,0,2.45-1.93,2.27,2.27,0,0,0-2.08-2.4A2.17,2.17,0,0,0,343.79,186.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.1,181c.27.31,2.06-.87,4.5-.74s4.17,1.43,4.45,1.15c.14-.13-.12-.68-.87-1.28a6.22,6.22,0,0,0-3.55-1.29,6.06,6.06,0,0,0-3.6,1C345.26,180.3,345,180.83,345.1,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.33,198.65c0-.14-1.49-.48-3.93-.91-.62-.1-1.21-.25-1.29-.68a3.13,3.13,0,0,1,.51-1.83c.66-1.48,1.35-3,2.08-4.66,2.9-6.64,5-12.11,4.76-12.23s-2.83,5.18-5.73,11.81l-2,4.7a3.57,3.57,0,0,0-.44,2.43,1.51,1.51,0,0,0,1,1,3.7,3.7,0,0,0,1.05.2C333.78,198.7,335.32,198.79,335.33,198.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,200.7c-.39,0-.53,2.61-2.9,4.38s-5.17,1.34-5.21,1.71c0,.16.61.54,1.8.63a6.59,6.59,0,0,0,4.34-1.27,5.77,5.77,0,0,0,2.26-3.68C342.89,201.36,342.62,200.69,342.44,200.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,171.36c.21.67,2.66.48,5.51,1s5.13,1.38,5.54.8c.19-.27-.18-.92-1.09-1.61a9.69,9.69,0,0,0-8.42-1.35C345.42,170.54,344.86,171,345,171.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.35,172.29c.4.57,2.12.08,4.14.15s3.72.56,4.15,0c.18-.27-.06-.84-.78-1.4a6,6,0,0,0-6.68-.13C322.44,171.45,322.18,172,322.35,172.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,164.15s4.69-9.76,9.61-11.84c5.95-2.53,8.14,4,13.76,2.71s11.3-3.7,16.75.86c6,5,2.9,8.14,2.93,15.22.13,28.69,4.95,37,7.11,23.64.24-1.47,4.39-2.44,5.31-8.65,1.19-8.05,2-17.86.47-23.69-1.28-4.91-3.88-8.39-8.64-12.32-7.52-6.21-18.24-6.87-25.56-6.49S319.92,151.64,320,164.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.13,194.25a4.32,4.32,0,0,1,4.87-3.93c2.95.43,6.17,2.28,5.67,8.4-.89,10.86-11.61,7.73-11.6,7.42S368.72,198.79,369.13,194.25Z",
    style: {
      fill: "#937263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,202.24c.05,0,.18.15.49.32a1.91,1.91,0,0,0,1.41.15c1.18-.33,2.3-2.07,2.51-4a6.17,6.17,0,0,0-.31-2.75,2.18,2.18,0,0,0-1.3-1.57,1,1,0,0,0-1.16.43c-.17.29-.12.51-.18.52s-.22-.2-.09-.64a1.17,1.17,0,0,1,.48-.64,1.42,1.42,0,0,1,1.07-.19,2.66,2.66,0,0,1,1.84,1.84,6.34,6.34,0,0,1,.4,3.08c-.24,2.18-1.53,4.14-3.14,4.46a2,2,0,0,1-1.7-.43C370.76,202.51,370.72,202.26,370.76,202.24Z",
    style: {
      fill: "#5e483f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,173.18a10.32,10.32,0,0,1-4.71,1.89c-1.71.09-3.61-1-3.81-2.69-.09-.76.14-1.63-.33-2.24s-1.67-.56-2.58-.51a7,7,0,0,1-7-5.34c-.87,1.17-2.74,1-3.93.18a15.51,15.51,0,0,1-2.8-3.32c-.9-1.14-2.19-2.18-3.64-2.05a10.5,10.5,0,0,1-2.39.41c-1.42-.2-2-1.91-2.18-3.34s-.23-3.09-1.4-3.92-2.56-.43-3.89-.3-3-.26-3.27-1.57a2.55,2.55,0,0,1,.58-1.94,7.06,7.06,0,0,1,8.45-2.26,9.55,9.55,0,0,1,17.62-1A9.71,9.71,0,0,1,370,149.51a7,7,0,0,1,7.41,10.6c1.9,1.22,3.48,3.24,3.41,5.5s-2.38,4.38-4.52,3.68a3.9,3.9,0,0,1-6.92,3.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.13,149.34a.63.63,0,0,0,0,.2c0,.13,0,.33,0,.59a6.9,6.9,0,0,0,.69,2.13,7.76,7.76,0,0,0,2.28,2.69,7.28,7.28,0,0,0,4.39,1.49l-.17-.25a4,4,0,0,0,.07,3,11.18,11.18,0,0,0,1.73,2.76,8.06,8.06,0,0,0,1.15,1.31A3.88,3.88,0,0,0,348,164a4,4,0,0,0,3.56-1.08l-.4-.14a8.15,8.15,0,0,0,3.18,5.81,6,6,0,0,0,3.52,1.35,10.67,10.67,0,0,0,3.55-.6l-.28-.14a8.66,8.66,0,0,0,2.41,3.49,4.57,4.57,0,0,0,3.73,1.22,6,6,0,0,0,4.85-4.46l-.25.1a5.55,5.55,0,0,0,3.7.73,6,6,0,0,0,2.67-1,5.06,5.06,0,0,0,1.28-1.27,2.31,2.31,0,0,0,.3-.55,6.38,6.38,0,0,1-1.68,1.67,6,6,0,0,1-2.6.92,5.39,5.39,0,0,1-3.5-.75l-.19-.13-.06.23a5.65,5.65,0,0,1-4.58,4.13,4.16,4.16,0,0,1-3.39-1.15,8.19,8.19,0,0,1-2.26-3.3l-.07-.21-.21.06a10.33,10.33,0,0,1-3.4.57,5.46,5.46,0,0,1-3.25-1.25,7.73,7.73,0,0,1-3-5.48l-.05-.52-.36.38a3.63,3.63,0,0,1-4.64.33,8.11,8.11,0,0,1-1.09-1.23,11,11,0,0,1-1.69-2.65,3.51,3.51,0,0,1-.1-2.73l.1-.25h-.28a7,7,0,0,1-4.21-1.36,7.74,7.74,0,0,1-2.27-2.55A8.49,8.49,0,0,1,336.13,149.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08,313.07,403.52,327l-4.67-26.61,29.3-9.26s7.78,36.51,9.14,45.15c2.42,15.5-.56,37.53-15,39.08-15.62,1.67-27.42-13.74-34.93-23.85-5.77-7.77-15.08-21.36-15.08-21.36l16.8-17.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,289.41c-4.7,14.8-11.27,17-13.87,59.45-.51,8.27,5.7,18.87,13.09,22.61s20.28-.85,24.46-8l4.15-31.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,351.35a64,64,0,0,0-2.88-6.23,64.26,64.26,0,0,0-4-5.6,6.55,6.55,0,0,1,1.51,1.37,22.86,22.86,0,0,1,4.92,8.47A6.43,6.43,0,0,1,296.88,351.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.38,306.47c.25-.87,14.71-40.23,19.32-48.85,5.52-10.31,17.12-14.86,24.32-15.31S398.3,248,398.3,248s21.59,5.42,25.95,25c5.48,24.49,9.89,48.65,9.89,48.65L395.51,330,391,318.51l-72.59,16.2-17.72-26.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.84,398.11,402,332.5l1.43-82.25L373.29,237l-3.38-13-35.14,16.61-7.36-8.13-3.08,9.16-7.7,2.52L301.48,274l-.66,52.4s-3.67,61.76-1.5,78.21c0,0,5.68,9.42,23.14,9.84,35.4.85,81.38-16.38,81.38-16.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.26,308.34c0,.14-1.78,0-4.62-.2l-11.07-.93-11.08-.82c-2.84-.22-4.59-.39-4.59-.53a20.87,20.87,0,0,1,4.62-.18c2.85,0,6.79.19,11.13.54s8.25.8,11.07,1.21S373.27,308.2,373.26,308.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.77,313.73c0,.14-1.78,0-4.62-.2l-11.07-.92L346,311.78c-2.84-.22-4.59-.38-4.59-.53a20.87,20.87,0,0,1,4.62-.18c2.85,0,6.79.2,11.13.54s8.25.8,11.07,1.21A20.84,20.84,0,0,1,372.77,313.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,319.12c0,.14-1.78,0-4.62-.2L356.59,318l-11.08-.83c-2.84-.21-4.59-.38-4.59-.52s1.77-.22,4.62-.19,6.79.2,11.13.54,8.25.8,11.07,1.22A20.35,20.35,0,0,1,372.28,319.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.79,324.51c0,.14-1.78,0-4.62-.2l-11.07-.92L345,322.56c-2.84-.21-4.59-.38-4.59-.52s1.77-.22,4.62-.18,6.79.19,11.13.53,8.25.8,11.07,1.22A20.35,20.35,0,0,1,371.79,324.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.43,416.17a1.54,1.54,0,0,1-.06-.42c0-.34-.06-.75-.1-1.25-.06-1.19-.15-2.79-.27-4.82-.19-4.27-.45-10.3-.78-17.71-.56-15-1.27-35.65-1-58.52.14-11.44.52-22.35,1.62-32.23s2.83-18.63,4.36-26,3-13.21,4-17.28c.49-2,.89-3.52,1.17-4.67.14-.49.24-.88.33-1.21a1.37,1.37,0,0,1,.15-.41,2.62,2.62,0,0,1,0,.43c-.07.34-.15.74-.24,1.23-.25,1.16-.59,2.73-1,4.72-.88,4.09-2.2,10-3.67,17.33s-3.07,16.11-4.15,25.93-1.4,20.72-1.54,32.13c-.24,22.84.37,43.52.76,58.49.2,7.42.37,13.45.48,17.72.05,2,.08,3.64.1,4.83v1.25A1.21,1.21,0,0,1,322.43,416.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,287.5a14.85,14.85,0,0,1,2,.06l5.94.36,21.67,1.48.41,0,0,.41c-.75,9.93-1.64,21.81-2.61,34.65l0,.23-.18.13c-1,.74-2.11,1.48-3.24,2.21a64.46,64.46,0,0,1-6.09,3.53,17.89,17.89,0,0,1-6.61,2.13,13.21,13.21,0,0,1-6.55-1.52,28.79,28.79,0,0,1-5.3-3.54c-.79-.66-1.56-1.33-2.29-2a4.21,4.21,0,0,1-1-1.24,6.44,6.44,0,0,1-.58-1.46,22.64,22.64,0,0,1-.53-5.71,83.4,83.4,0,0,1,.91-10.12c.9-6.14,2-11,2.73-14.41.38-1.69.71-3,.94-3.87a7.29,7.29,0,0,1,.42-1.33,8.47,8.47,0,0,1-.22,1.37c-.19,1-.45,2.29-.76,3.91-.65,3.39-1.6,8.31-2.4,14.43a83.7,83.7,0,0,0-.79,10,21.68,21.68,0,0,0,.55,5.47,4.19,4.19,0,0,0,1.37,2.27c.72.67,1.48,1.32,2.27,2a27.68,27.68,0,0,0,5.13,3.4,12.19,12.19,0,0,0,6.07,1.4,17.11,17.11,0,0,0,6.22-2,61.58,61.58,0,0,0,6-3.48c1.11-.72,2.21-1.46,3.2-2.18l-.21.37c1-12.83,2-24.71,2.79-34.63l.38.44-21.4-1.88-6-.57-1.6-.18A2.54,2.54,0,0,1,345.08,287.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.91,224s-3.93,1.14-14,6.52c-9.88,5.27-21.12,10.09-21.12,10.09l.86,15.87L373,237.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "327.41 232.48 334.77 240.61 330.84 257.62 324.28 242.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.47,298.79c0,.28-7.05-.05-15.7-.72s-15.65-1.45-15.63-1.72,7.05,0,15.7.72S374.49,298.52,374.47,298.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.64,324.31c1.69,2.79,3.27,6.61,5.58,8.91a13.7,13.7,0,0,0,8.56,4.27,14,14,0,0,0,8.12-2.42c3.93-2.46,6.35-6.33,8.1-10.62.25-.32-5.62,3.6-8.81,5.3a14.34,14.34,0,0,1-9,1.93c-4.72-.38-8.95-4.27-12.53-7.37"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.64,242.37c-.33.24-2.37,19.63-2.37,19.63l37.48-22.65-34.12,17.13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.23,261.28a552,552,0,0,0-12.54,81.83c-1.44,19.12-2.52,44.46-2.52,44.46l8.53,10.56,13.07-11.57s-.56-53.82.12-71.84c.56-14.83-1.78-52.66-1.78-52.66Z",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.49,285.21a9.79,9.79,0,0,1,.35,1.53c.19,1.09.45,2.51.76,4.21.63,3.65,1.46,8.52,2.39,13.9s1.75,10.36,2.28,13.93c.27,1.78.47,3.23.6,4.23a9.87,9.87,0,0,1,.15,1.57,8.53,8.53,0,0,1-.35-1.54c-.2-1.08-.45-2.5-.76-4.2-.64-3.65-1.49-8.52-2.44-13.9s-1.7-10.36-2.23-13.93c-.25-1.72-.45-3.14-.6-4.23A8.62,8.62,0,0,1,394.49,285.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,252.55c.06.07-1,.91-2.53,2.47a30.85,30.85,0,0,0-8,14.78c-.46,2.13-.57,3.48-.66,3.48a3.17,3.17,0,0,1,0-1,19.52,19.52,0,0,1,.31-2.59,27.84,27.84,0,0,1,2.85-8.12,27.38,27.38,0,0,1,5.2-6.85,19,19,0,0,1,2-1.69A3.33,3.33,0,0,1,405.63,252.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.89 248.2 331.54 246.89 328.37 252.34 327.8 261.28 332.27 262 335.63 256.48 334.89 248.2",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.69,274.8c.14,0,.26,22,.26,49.2s-.12,49.21-.26,49.21-.26-22-.26-49.21S298.54,274.8,298.69,274.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,240.47c.06.05-.73,1.25-1.91,3.24a89.36,89.36,0,0,0-4.26,8l-.35.76-.24.51-.24-.5a61.56,61.56,0,0,1-3.12-7.93c-.33-1-.56-1.87-.7-2.45a2.76,2.76,0,0,1-.17-.92c.07,0,.47,1.24,1.2,3.26s1.82,4.8,3.26,7.81h-.47l.36-.77a67.21,67.21,0,0,1,4.41-8c.64-1,1.18-1.74,1.57-2.26A3.67,3.67,0,0,1,335.13,240.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,237a2.84,2.84,0,0,1-.52.31l-1.51.79-5.59,2.9c-4.71,2.45-11.17,5.94-18.32,9.76-4.36,2.32-8.48,4.47-12.07,6.27l-.33.17v-.37c0-4.66-.08-8.58-.11-11.42,0-1.33,0-2.4,0-3.21a6.53,6.53,0,0,1,.05-1.15,6.93,6.93,0,0,1,.09,1.14c0,.81.07,1.89.12,3.22.08,2.84.18,6.76.3,11.41l-.33-.2c3.57-1.83,7.68-4,12-6.32,7.15-3.82,13.64-7.26,18.4-9.63,2.38-1.19,4.32-2.12,5.67-2.75l1.56-.7A3.07,3.07,0,0,1,373.29,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.21,249.21c.07,0-.51,1-1.27,2.74a31.08,31.08,0,0,0-2.15,6.9,31.91,31.91,0,0,0-.45,7.21c.11,1.85.3,3,.22,3a2.51,2.51,0,0,1-.24-.79,19,19,0,0,1-.34-2.2,25.88,25.88,0,0,1,.3-7.33,26.22,26.22,0,0,1,2.33-7,16.35,16.35,0,0,1,1.1-1.93C303,249.42,303.18,249.19,303.21,249.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.45,262.57c-.08.13-.93-.27-1.9-.89s-1.7-1.21-1.62-1.33.93.28,1.9.89S331.53,262.45,331.45,262.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,260.39a24.32,24.32,0,0,1-2.28-4.53,24.7,24.7,0,0,1-1.79-4.73,24.68,24.68,0,0,1,2.27,4.53A25.18,25.18,0,0,1,333.06,260.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.86,350.6a.8.8,0,0,1-.14-.23c-.09-.17-.2-.4-.35-.68s-.34-.68-.56-1.11-.59-.9-.95-1.43a51.67,51.67,0,0,0-7.5-8.15c-3.5-3.21-7.93-6.83-12.92-11-2.48-2.09-5.12-4.27-7.76-6.71a73.49,73.49,0,0,1-7.8-8.1h.38L374.21,329c-.69.72-1.38,1.43-2,2.1l0-.33c5.69,8.32,10.87,16.37,16.31,23.12a108.67,108.67,0,0,0,8.19,9.15,67,67,0,0,0,8,7.09c5.2,3.93,10.42,5.61,14.05,5.52.46,0,.89,0,1.29,0l1.11-.12,1-.1.78-.18,1.06-.23.36-.06a1.84,1.84,0,0,1-.35.11l-1.05.28-.78.2-1,.13-1.12.14c-.41,0-.84,0-1.3,0-3.67.16-9-1.51-14.27-5.43a67.37,67.37,0,0,1-8-7.08,109.15,109.15,0,0,1-8.25-9.15c-5.48-6.76-10.68-14.82-16.37-23.13l-.12-.17.15-.15,2-2.1L388.9,312.9l.2-.21.18.23A74.26,74.26,0,0,0,397,321c2.63,2.43,5.26,4.63,7.73,6.72,5,4.15,9.38,7.81,12.85,11.06a49.08,49.08,0,0,1,7.43,8.29c.35.54.65,1,.92,1.45l.53,1.15.31.7A2.52,2.52,0,0,1,426.86,350.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.23,339.56a3.42,3.42,0,0,0-1.16-2.19c-1.24-.81-2.8.26-4.07,1-3.35,2-7.49,1.93-11.39,1.76a286.17,286.17,0,0,1-35.08-3.33c-5.67-.95-11.4-2.19-16.47-4.91s-9.5-7.09-11.13-12.61l-2.72-1.47c2.11,4.49,1.89,17.19,2.64,22.08s2.93,8.39,7.64,9.91a16.56,16.56,0,0,0,5.92.42c19.33-1,38.83-.09,58.16-1,2.77-.14,6-.52,7.45-2.85C355.27,344.38,354.77,341.82,354.23,339.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M366.43,295.68s-9.16-10.48-10.8-9.32-4,1.79-1.73,6,6.1,6.63,6.82,10.24-.09,12.31,3.94,15.26,9.64,10.61,9.64,10.61l14-14.6-5.54-4.17s3.35-8.36,3.32-12.73-3-9.83-3-9.83a10.24,10.24,0,0,0-3-5.7,45.22,45.22,0,0,0-1.11-5.57c-.75-2.77-10.79-12.45-10.79-12.45a4.29,4.29,0,0,0-1.13,5.85,55.12,55.12,0,0,0,4.59,6.38l-9.17-1.1a4.81,4.81,0,0,0,3.87,5.9c5.05,1.29,6.24,3.14,6.24,3.14l-6.25,2.07s.29,3.69,3,3.78l2.73.08Z",
    style: {
      fill: "#937263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81,289.41l6.06-.2H375l.06.07a10.62,10.62,0,0,1,2.4,4.83,9.66,9.66,0,0,1-1.24,6.34,22.69,22.69,0,0,1-4.79,5.07,15,15,0,0,0-3.59,4.23,7,7,0,0,0-.8,3.6c.06.89.28,1.35.23,1.37s-.07-.11-.17-.33a4.09,4.09,0,0,1-.26-1,6.79,6.79,0,0,1,.67-3.78,14.7,14.7,0,0,1,3.6-4.42,23.5,23.5,0,0,0,4.66-5,9.33,9.33,0,0,0,1.21-6,10.4,10.4,0,0,0-2.22-4.66l.16.07C371.14,289.63,368.8,289.55,368.81,289.41Z",
    style: {
      fill: "#5e483f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.59,287c-.08,0-.34-.49-.93-1.2a6,6,0,0,0-3-1.86,12,12,0,0,0-3.58-.34,5.77,5.77,0,0,1-1.54,0,4,4,0,0,1,1.51-.37,9.57,9.57,0,0,1,3.75.21,6.38,6.38,0,0,1,1.91.91,5.11,5.11,0,0,1,1.2,1.23A2.91,2.91,0,0,1,381.59,287Z",
    style: {
      fill: "#5e483f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.09,280.13c-.11.11-1.47-1.26-3.49-2.44s-3.88-1.72-3.84-1.87a11,11,0,0,1,7.33,4.31Z",
    style: {
      fill: "#5e483f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.13,294l12.05,45.52a5.66,5.66,0,0,0,5.58,4.21l62.39-1.23a5.66,5.66,0,0,0,5.43-6.82l-9.19-43.6a5.66,5.66,0,0,0-5.54-4.49H272.07A5.11,5.11,0,0,0,267.13,294Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.89,304.27a4.56,4.56,0,0,1,0-5.65,7,7,0,0,1,5.35-2.53,15.41,15.41,0,0,1,6,1.24,39,39,0,0,1,6.75,3.37c1.51.95,3.07,2.18,3.36,3.93s-1.61,3.76-3.16,2.88a7.45,7.45,0,0,1,4.36,5.19c.33,2.23-.86,3.42-3,4.06A3.35,3.35,0,0,1,283.4,321c-.79,1.67-3.09,2.13-4.81,1.47a11.2,11.2,0,0,1-4.2-3.52,10.26,10.26,0,0,1,1.2,7.05,13.78,13.78,0,0,1-9-11.08,6.38,6.38,0,0,1-1.74-7.84c-1.91-.59-4.08-3.52-3.93-5.52",
    style: {
      fill: "#937263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.43,316.78a16.76,16.76,0,0,1-2.06-1.57,13.77,13.77,0,0,0-5.41-2.77,7.64,7.64,0,0,0-3.3,0,6.09,6.09,0,0,0-2.4,1.21,7.66,7.66,0,0,0-1.57,2,1.64,1.64,0,0,1,.19-.69,4.66,4.66,0,0,1,1.14-1.56,6.08,6.08,0,0,1,2.52-1.39,7.48,7.48,0,0,1,3.53-.05,12.63,12.63,0,0,1,5.53,3A10,10,0,0,1,281.43,316.78Z",
    style: {
      fill: "#5e483f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,307.73a11.57,11.57,0,0,1-2.49-1,25.92,25.92,0,0,0-2.66-1.16,21.81,21.81,0,0,0-3.42-.89,9.6,9.6,0,0,0-3.46,0,6.27,6.27,0,0,0-2.57,1.11,6.51,6.51,0,0,0-1.68,2s0-.28.2-.71a4.46,4.46,0,0,1,1.25-1.59,6.25,6.25,0,0,1,2.7-1.29,9.52,9.52,0,0,1,3.65,0,19.79,19.79,0,0,1,3.5.95,21.33,21.33,0,0,1,2.65,1.28A17.66,17.66,0,0,1,280.9,307.73Z",
    style: {
      fill: "#5e483f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.83,370.68c-.5-1.8.15-1.81-1.28-3a112.9,112.9,0,0,1-14.45-15.21c-4.44-5.56-11.37-16.84-11.37-16.84l-1.64-.5c1.42,8.13,5.51,15.5,9.54,22.71A62.76,62.76,0,0,0,391,369.09c3,3.37,6.86,6.14,11.28,7A7.05,7.05,0,0,0,402.83,370.68Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.61,264.81a5.72,5.72,0,0,1,.07,1q0,1.1.06,2.88c0,.63,0,1.33,0,2.08s.12,1.58.18,2.47c.15,1.76.23,3.78.57,6,.15,1.11.3,2.27.46,3.48s.42,2.45.64,3.74c.42,2.6,1.06,5.33,1.68,8.22,1.34,5.75,3,12,4.81,18.63s3.41,12.9,4.66,18.69c.57,2.92,1.17,5.67,1.52,8.29.19,1.3.41,2.56.55,3.77s.24,2.39.35,3.51c.27,2.22.27,4.26.34,6,0,.89.07,1.72.06,2.48s-.06,1.45-.09,2.09q-.09,1.79-.15,2.88a7.13,7.13,0,0,1-.1,1,5,5,0,0,1,0-1c0-.73,0-1.69,0-2.88,0-.63,0-1.32,0-2.08s-.08-1.58-.12-2.47c-.11-1.77-.14-3.79-.45-6q-.18-1.67-.39-3.48c-.15-1.21-.39-2.45-.59-3.75-.37-2.6-1-5.34-1.57-8.24-1.29-5.76-2.92-12.06-4.71-18.65S98,300.6,96.65,294.82c-.6-2.9-1.23-5.65-1.62-8.26-.21-1.3-.45-2.55-.61-3.76s-.28-2.38-.41-3.5c-.32-2.22-.36-4.25-.47-6,0-.89-.11-1.72-.12-2.48l0-2.09c0-1.2.05-2.15.07-2.88A5,5,0,0,1,93.61,264.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.12,312.73l14.15-50.33,17.41,3.17s-4.17,4.75-4.17,9.12-2.9,45.56-2.9,45.56-17.31,5.08-24.31-6.64",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.27,262.4s-1.94-5.25-.41-9.79,6.76-8.06,6.43-10.79,2.45-9.26,5-8.75,4.34,3,2.23,7.18a53.91,53.91,0,0,0-3.34,8.54s26-13.55,28.13-13.84,4.25-.59,4.8,1.11-4.64,3.86-4.64,3.86l-7,9.09a39.91,39.91,0,0,1-4.85,9.78c-3,4.06-8.91,6.78-8.91,6.78l-7.58,9.12S243.6,270.77,245.27,262.4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,240.28s-.23-.15-.64-.35a3.11,3.11,0,0,0-1.85-.22,10.33,10.33,0,0,0-5.23,3.55,27.06,27.06,0,0,0-3.51,5.54,11.4,11.4,0,0,1-1.36,2.41,10.16,10.16,0,0,1,.9-2.63,21.77,21.77,0,0,1,3.43-5.79c1.74-2,3.88-3.38,5.71-3.58a3.05,3.05,0,0,1,2.05.48C282.9,240,283,240.26,283,240.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.45,243.69c.1.17-1.58,1.31-3.74,2.55s-4,2.11-4.1,1.94,1.57-1.32,3.74-2.56S273.35,243.51,273.45,243.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.67,249.53c-.09-.17,2-.86,4.37,0s3.63,2.59,3.46,2.67-1.49-1.28-3.69-2S259.7,249.74,259.67,249.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34,315.64c-.13.75,19.7,27.51,26.13,32.53,15.78,12.31,27.38-4.34,26.22-18.43s-42.15-80.31-42.15-80.31L202.27,280.7Z",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.56 242.34 137.62 233.87 141.02 228.12 177.19 228.7 185.59 237.69 209.69 249.53 189.46 334.46 121.58 337.95 101.56 242.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,227l-13.49,8.37L101,241.54l9,113.82S83.42,407.09,79.36,452H150.9s6.77-57.13,6.06-80-.27-63-.27-63l-18.46-69Z",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.71,235.43l-2.52-7.77,9.42,9.48s5.58,1.94,6.78,2.38c9.37,3.5,22.15,9.91,22.15,9.91l-16,101.17S221,407.72,219.25,452c0,0-49,.81-68.35,0l5.23-145.25s17-20.07,19.83-40.27S179.71,235.43,179.71,235.43Z",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.26,322.75a5,5,0,0,1-.63-.62l-1.71-1.85-6.31-7-21.31-24-.14-.15.06-.19c1.08-3.91,2.22-8,3.39-12.21.5-1.82,1-3.62,1.5-5.4l.34.47-14.14-.54-.48,0,.17-.45c3.83-10.33,7.12-19.17,9.47-25.51,1.17-3.08,2.11-5.54,2.79-7.31.31-.8.57-1.44.76-1.94a3.24,3.24,0,0,1,.31-.66,4.13,4.13,0,0,1-.2.7l-.66,2-2.59,7.38c-2.3,6.37-5.5,15.25-9.23,25.61l-.31-.47,14.14.5.47,0-.13.45c-.49,1.77-1,3.58-1.5,5.4-1.17,4.2-2.31,8.3-3.4,12.2l-.08-.33L147,313c2.57,3,4.65,5.41,6.14,7.13l1.62,1.94A4,4,0,0,1,155.26,322.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,452c-.2,0,.74-32.79,2.11-73.21s2.64-73.2,2.84-73.19-.74,32.78-2.1,73.21S151.21,452,151,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.52,236.76a5.12,5.12,0,0,1,.16.81c.09.6.2,1.38.34,2.36.28,2.13.67,5.1,1.16,8.78.93,7.56,2.22,18,3.7,30l.06.48-.48-.08-7.84-1.35.41-.52,1.49,3.34,2.94,6.58.09.21-.15.18-21.73,25.2-6.51,7.42c-.73.82-1.32,1.48-1.78,2s-3.1,2.47-3.12,2.46,2.64-2.07,3-2.55L160,320l6.34-7.57,21.54-25.36-.06.39-2.94-6.57-1.49-3.35-.29-.63.69.12,7.84,1.36-.43.4c-1.38-12-2.58-22.48-3.45-30-.39-3.7-.71-6.68-.94-8.82-.09-1-.16-1.76-.22-2.36A3.48,3.48,0,0,1,186.52,236.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.5,405.75c-1.44-1.91-4.35-3.09-5.84-1.22l.05,0a4.58,4.58,0,0,0-1.55,5,4.43,4.43,0,0,0,5.88,2.39A4.26,4.26,0,0,0,146.5,405.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.73,367.28c-1.44-1.9-4.36-3.08-5.85-1.21l.06,0a4.56,4.56,0,0,0-1.55,5,4.42,4.42,0,0,0,5.87,2.39A4.27,4.27,0,0,0,148.73,367.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.32,270.92c.24.77,5.32,1.55,6.21,3.69s.45,4.59-.18,6.83-1.45,4.48-1.29,6.8c.28,4.15,3.55,7.39,6.62,10.21,8.56,7.87,19,16.42,27.58,24.3-7.59-9.68-17.48-19.7-25.87-28.69a11.94,11.94,0,0,1-3-4.46c-.66-2.19,0-4.53.64-6.71l2.58-8.69c.22-.75.7-2,.81-2.41a18.45,18.45,0,0,0-3.18-.39s-7.55-.8-10.87-.48"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.2,266.56a3.28,3.28,0,0,1-.08.86c-.1.64-.23,1.45-.38,2.46-.38,2.22-.89,5.28-1.51,9-1.29,7.7-3,18.17-5,29.75s-3.79,22.12-5.2,29.71c-.71,3.8-1.3,6.86-1.74,9q-.31,1.49-.51,2.43a3.36,3.36,0,0,1-.23.84,4.66,4.66,0,0,1,.09-.87c.1-.63.22-1.45.38-2.45.37-2.22.88-5.28,1.51-9l5-29.74c1.95-11.62,3.79-22.12,5.2-29.71.71-3.8,1.3-6.87,1.73-9,.21-1,.38-1.8.52-2.43A4,4,0,0,1,214.2,266.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,241.43a25.28,25.28,0,0,0-13,10c-6,8.86-16.36,94.81-16,100.77S78.1,373.28,92,371.29s50.88-27.82,50.88-27.82l-12.72-24.64-27,12.72L106.83,289Z",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.46,363c-.88-3.87-5.67-5.11-9.6-5.61l-64.1-8.18-5.56,18c.57,4.13,1.15,8.34,2.91,12.12s4.89,7.15,8.94,8.14c3.58.87,7.32-.18,10.85-1.23l47.14-14a19.46,19.46,0,0,0,6.68-2.93C182.64,367.92,184,365.42,183.46,363Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.54,288.66c-.77-3-1.94-6.5-4.87-7.65-3.12-1.22-6.74,1.05-8.13,4.1s-1.09,6.58-.6,9.89c1.7,11.52,5.76,24.3,9.52,35.32l13.15-4.83C111.87,313.29,107.57,300.61,104.54,288.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,278.17l-12.94,39,16.8,12.2,13.54,5.44c0-.07,2.53-19.48,1.89-12.7l3-40.05Z",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,278.17a9.7,9.7,0,0,1-.31,1.73c-.22,1.11-.6,2.7-1.11,4.65-1,3.92-2.72,9.24-4.8,15s-3.84,11.08-4.94,15c-.55,1.94-1,3.51-1.27,4.61a9.86,9.86,0,0,1-.51,1.68,12.79,12.79,0,0,1,.31-1.73c.23-1.11.61-2.7,1.12-4.66,1-3.91,2.72-9.23,4.8-15s3.83-11.08,4.94-15c.55-1.94,1-3.52,1.27-4.61A12.18,12.18,0,0,1,240.37,278.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.15,336.91a11.18,11.18,0,0,1-1.61-2.07,56.32,56.32,0,0,1-3.27-5.41,59,59,0,0,1-2.65-5.73,12.21,12.21,0,0,1-.81-2.49,15.07,15.07,0,0,1,1.15,2.34c.67,1.46,1.62,3.47,2.77,5.64s2.28,4.08,3.12,5.45A16.22,16.22,0,0,1,236.15,336.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,329a24.74,24.74,0,0,1-4.09-1.34,24,24,0,0,1-4-1.54,14.35,14.35,0,0,1,4.2,1.05A14.27,14.27,0,0,1,101.5,329Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.57,273.7a3,3,0,0,1-.4-.86c-.23-.57-.53-1.4-.86-2.45a56.46,56.46,0,0,1-2.58-16.87c0-1.09,0-2,.08-2.59a3.16,3.16,0,0,1,.13-.94c.08,0,.07,1.35.16,3.53a73.56,73.56,0,0,0,2.57,16.77C105.23,272.39,105.65,273.68,105.57,273.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17,281.64l4.73.32a8.93,8.93,0,0,0-8.9-3.34c.11,2.85,3.08,5.07,2.9,7.92a7.58,7.58,0,0,1-2.07,4L176,301.41l.62,5.44c3.61-5.15,7.25-10,10.86-15.1a13.89,13.89,0,0,0,2.59-5.09C190.47,284.77,189.85,282.56,188.17,281.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.11,296.09l1.43-4.21c-2.41,7.23-10.59,12.78-13.28,19.91a18.78,18.78,0,0,0,3,18.11c.93,1.14,2.53,2.24,3.75,1.41a2.49,2.49,0,0,0,1.16-2.72c-.38-1-3.19-6.83-3.69-7.75-.37-.7.47-2.71,1.59-6.47C231,307.73,233.13,302.72,235.11,296.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M131,181.75a45.43,45.43,0,0,0,14.51,34.33L152,197.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.86,144.38c-5.57-3-12.29-3.48-18.51-2.24s-12,4.07-17.51,7.24c-3.09,1.79-6.16,3.75-8.37,6.53-4.05,5.09-8,13.44-8.43,19.93-.32,5.24,1.69,18.37,3.91,23.13,2,4.37,11.55,7.7,16.25,8.78l43.12-50.14A21.85,21.85,0,0,0,179.86,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.29,151.14,177,149.29c5.65,13.46,7.18,44.23,10.41,58.46,3.81-5.53,12.66-22.37,12.19-29.06S199.57,150,187.29,151.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2,173.08c-.67-10.33-7.54-23-17.83-21.87l-23.8,6.07a17.67,17.67,0,0,0-13.28,16.26c0,.39-.07-.09-.06.21l5.31,61.63,17.87,35.46h0l15.77-37.19c0-5,0-9,0-9s13.19-2.22,15.88-19.44C194.41,196.65,194,184.55,193.2,173.08Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,186.08a2.2,2.2,0,0,1-2.13,2.23,2.12,2.12,0,0,1-2.28-2,2.2,2.2,0,0,1,2.12-2.23A2.12,2.12,0,0,1,189.05,186.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62,179.82c-.27.29-2-.94-4.32-.93s-4.12,1.2-4.38.91c-.12-.13.15-.65.91-1.2a6.11,6.11,0,0,1,3.5-1.09,5.8,5.8,0,0,1,3.44,1.1C190.5,179.17,190.75,179.69,190.62,179.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.44,186.08a2.2,2.2,0,0,1-2.13,2.23,2.12,2.12,0,0,1-2.28-2,2.2,2.2,0,0,1,2.12-2.23A2.12,2.12,0,0,1,168.44,186.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.06,179.82c-.27.29-1.95-.94-4.32-.93s-4.12,1.2-4.38.91c-.12-.13.15-.65.91-1.2a6.11,6.11,0,0,1,3.5-1.09,5.87,5.87,0,0,1,3.44,1.1C167.94,179.17,168.19,179.69,168.06,179.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.49,198.48c0-.14,1.46-.4,3.85-.71.61-.06,1.18-.18,1.28-.6a3,3,0,0,0-.4-1.79q-.87-2.2-1.81-4.62c-2.5-6.57-4.32-12-4-12.07s2.51,5.15,5,11.72c.61,1.62,1.18,3.16,1.73,4.64a3.5,3.5,0,0,1,.32,2.38,1.53,1.53,0,0,1-1,.89,4.14,4.14,0,0,1-1,.14A15.65,15.65,0,0,1,175.49,198.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,218.53s5.6,11.82,22.82,10.17v-4A43.33,43.33,0,0,1,154.36,218.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,171.24c-.23.64-2.6.34-5.39.69s-5,1.1-5.41.52c-.16-.27.23-.88,1.14-1.51a9.48,9.48,0,0,1,8.23-.93C166.9,170.42,167.41,170.93,167.31,171.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,172.56c-.41.54-2.05,0-4,0s-3.63.37-4-.2c-.16-.27.1-.81.82-1.32a5.85,5.85,0,0,1,6.48.18C189.8,171.74,190,172.29,189.84,172.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.53,157.36a7.59,7.59,0,0,0-6.69-4.29,14.71,14.71,0,0,0-7.94,2.32c-10.25,5.92-15.52,20.23-25.65,26.36-2.49,1.51-5.73.13-7.85,2.13s-3.49,5.18-2.32,7.85a24.15,24.15,0,0,1-3.51-5.94,8.09,8.09,0,0,1,.28-6.71c.88-1.52,2.42-2.68,2.85-4.38.37-1.5-.22-3.06-.15-4.6a9.94,9.94,0,0,1,1.57-4.39c4-7,9.43-13.37,16.46-17.31a29.09,29.09,0,0,1,15.1-3.91,22.26,22.26,0,0,1,14.37,5.7c2.27,2.12,4.65,4.3,3.48,7.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65,186c-.18-.49-9.16-3.73-9.28,5.81-.12,9.27,9.24,7.44,9.26,7.18S140.65,186,140.65,186Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,195.46s-.16.11-.44.23a1.61,1.61,0,0,1-1.2,0c-1-.37-1.79-1.93-1.82-3.61a5.31,5.31,0,0,1,.47-2.3,1.87,1.87,0,0,1,1.23-1.23.82.82,0,0,1,1,.45c.12.26.06.44.11.46s.2-.15.13-.54a1,1,0,0,0-.36-.58,1.21,1.21,0,0,0-.89-.24,2.24,2.24,0,0,0-1.7,1.42,5.51,5.51,0,0,0-.59,2.58c.05,1.86,1,3.62,2.32,4a1.7,1.7,0,0,0,1.48-.23C137.78,195.68,137.83,195.48,137.8,195.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,181.24a2.56,2.56,0,0,0,.56-.31c.35-.22.9-.52,1.55-1a31.4,31.4,0,0,0,5-4.55,89.49,89.49,0,0,0,6.12-7.95,73.42,73.42,0,0,1,7.65-9.53,29,29,0,0,1,4.94-3.9,23.63,23.63,0,0,1,5.33-2.42,26.46,26.46,0,0,1,9.82-1.21,25.38,25.38,0,0,1,6.58,1.29c.76.23,1.33.49,1.72.64a3.2,3.2,0,0,0,.6.21,4.05,4.05,0,0,0-.57-.29,14.9,14.9,0,0,0-1.69-.71,24.18,24.18,0,0,0-6.62-1.44,26.24,26.24,0,0,0-10,1.14,24.11,24.11,0,0,0-5.43,2.43,29.51,29.51,0,0,0-5,4,70.52,70.52,0,0,0-7.67,9.6,93.53,93.53,0,0,1-6,8,34.39,34.39,0,0,1-4.88,4.62c-.64.48-1.17.8-1.51,1.05A4.14,4.14,0,0,0,137,181.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.75,197.1a1.84,1.84,0,1,0,.43.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,197.24a2.45,2.45,0,0,1,.83,1.24,1.58,1.58,0,0,1-.36,1.46,1.62,1.62,0,0,1-2.85-.91,1.56,1.56,0,0,1,.55-1.4,2.43,2.43,0,0,1,1.4-.53s-.15-.1-.44-.1a1.93,1.93,0,0,0-1.9,2.07,2,2,0,0,0,3.53,1.13,1.85,1.85,0,0,0,.36-1.8,1.93,1.93,0,0,0-.71-1C137.35,197.24,137.19,197.21,137.18,197.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.29,183.87c-.14,2.53-.26,5.2.91,7.45s4.12,3.79,6.32,2.53c1.8-1,2.34-3.33,2.64-5.38.88-5.9,1.28-11.87,2.21-17.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,203a4.58,4.58,0,0,0,2.29,7.17,2.7,2.7,0,0,0,1.73,0,3.85,3.85,0,0,0,1.84-2.39l1-2.4a.81.81,0,0,0-.69-1.3l-5.95-1.43",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.54,209.9a5.31,5.31,0,0,1-2.7-.34,4.23,4.23,0,0,1-2.37-1.93,3.2,3.2,0,0,1-.37-1.84,5.49,5.49,0,0,1,.48-1.9,4.87,4.87,0,0,1,1.11-1.55l.16-.14.2.07c3.94,1.39,7,2.09,7,2.26s-3.2-.26-7.22-1.6l.35-.08a4.51,4.51,0,0,0-.95,1.34,3.83,3.83,0,0,0-.17,3.14,3.9,3.9,0,0,0,2,1.76C172.5,209.69,173.57,209.77,173.54,209.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.24,153c0,.05-.81-.16-2.3-.2a15.79,15.79,0,0,0-6.14,1.12,19.81,19.81,0,0,0-3.84,2,40.15,40.15,0,0,0-4,3,48.37,48.37,0,0,0-7.76,8.37c-1.18,1.66-2.22,3.36-3.35,4.93a23.17,23.17,0,0,1-3.72,4.18,41.37,41.37,0,0,1-7.83,5.24c-2.37,1.26-4.36,2.13-5.72,2.74L140,185a2.69,2.69,0,0,1-.57.2,2.91,2.91,0,0,1,.53-.3l1.54-.76c1.34-.67,3.3-1.59,5.63-2.88a42.51,42.51,0,0,0,7.7-5.28,23.47,23.47,0,0,0,3.62-4.12c1.11-1.55,2.15-3.26,3.34-4.93a46.76,46.76,0,0,1,7.87-8.43,41.36,41.36,0,0,1,4-3,20.12,20.12,0,0,1,4-2,15.35,15.35,0,0,1,6.27-1,10.67,10.67,0,0,1,1.71.24A2,2,0,0,1,186.24,153Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,178.14a4.42,4.42,0,0,1-.82.55l-2.35,1.38-.79.46a2.51,2.51,0,0,1-1,.33,1,1,0,0,1-.63-.15.77.77,0,0,1-.34-.61,2.06,2.06,0,0,1,.44-1.17l2.72-4.36.37.34a9.8,9.8,0,0,1-3,1.49,10,10,0,0,1-3.32.39,2.87,2.87,0,0,1-.84-.15,1.11,1.11,0,0,1-.72-.63,1,1,0,0,1,.16-.93,3.79,3.79,0,0,1,.52-.58,19.33,19.33,0,0,0,3.16-4,34.13,34.13,0,0,0,2-4.27,5,5,0,0,1-.29,1.24,17.41,17.41,0,0,1-1.4,3.21,18.69,18.69,0,0,1-3.14,4.14c-.35.33-.69.71-.55,1s.63.43,1.12.44a9.37,9.37,0,0,0,6-1.78l1.1-.81-.74,1.15-2.78,4.33a1.81,1.81,0,0,0-.39.9c0,.27.23.42.53.4a4.7,4.7,0,0,0,1.67-.69l2.42-1.24A4.11,4.11,0,0,1,139,178.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81,286l16.86,88.65a6.52,6.52,0,0,0,7.65,5.19l64.75-12.46a6.54,6.54,0,0,0,5.18-7.68L169.41,269.5a6.55,6.55,0,0,0-7.81-5.12l-63.77,14A6.54,6.54,0,0,0,92.81,286Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,318.72l5.39-2.67s1.75-9.24,4.59-12.5,7-7,7-7.89,1.32-7,1.32-7,2.51-2.19,3,2.19a32.06,32.06,0,0,1,0,7.66l16.86-4.2c1.75-.44,3.94-.27,3.72,1.48s-1.16,2.66-2.5,3.75a5.65,5.65,0,0,1-1.61.94s2.81,2.59,2.81,5.13,2.88,8.44.26,11.28-14.66,11.38-21,12.47-7.9,3-10.84,6.74Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.69,298.21c.07.14-1.93,1.31-4.19,3.05s-3.92,3.34-4,3.24a21.18,21.18,0,0,1,8.23-6.29Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.75,300a14.36,14.36,0,0,1-4.05,1.66,25.22,25.22,0,0,1-4.2,1.15,14.53,14.53,0,0,1,4.05-1.65A27.2,27.2,0,0,1,174.75,300Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.41 331.37 135.54 315.63 149.47 343.4 98.41 369.44 98.41 331.37",
    style: {
      fill: "#1679AB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.83,316.49c.06.14-10,4.27-22.41,9.24s-22.55,8.88-22.6,8.75,10-4.27,22.41-9.24S134.78,316.36,134.83,316.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M100.86,329.66a71.35,71.35,0,0,0-13.19,4,17.47,17.47,0,0,0-4.89,2.72,7.11,7.11,0,0,0-2.63,4.8,16,16,0,0,0,3.42-2c4.22-4.23,11.49-6.69,17.65-9Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.66,452.4c0,.14-97,.26-216.65.26s-216.67-.12-216.67-.26,97-.26,216.67-.26S466.66,452.25,466.66,452.4Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.81b4a14b1a53dc1a5f23bdfaa17d5759.svg";
export { ForwardRef as ReactComponent };